import { FC, memo } from 'react'
import { Button, ButtonProps } from '@chakra-ui/react'
import { Pencil } from 'components/icons'

type Props = ButtonProps

const EditButton: FC<Props> = ({ children, ...props }) => {
  return (
    <Button leftIcon={<Pencil />} {...props}>
      {children}
    </Button>
  )
}

export default memo(EditButton)
